TS.ns('WL'); 

WL.fileInfoEditModel = new Class({
    Extends: TS.domain.EditDomain,


    initialize: function (config) {
        var me = this;

        me.parent(config);

        var fileInfoList = me.getDomainProperty('dgFileInfoCollection_Property');

        if (fileInfoList != null) {
            fileInfoList.getFieldByName('gcFileName_Field').renderer = "hyperlinkGrid";
            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };
        }
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);
        var fileInfoList = me.getDomainProperty('dgFileInfoCollection_Property');

        if (fileInfoList != null) {
            fileInfoList.on('cellBeginEdit', me.onFileInfoBeginEdit);
        }
    },

    onFileInfoBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName == 'FileName') {
            e.preventDefault();
            owner.performServerCommand({ cmd: 'OpenFile', submitModel: true, extraData: { UID: e.record.UID()}, blockUI: true });
        }
    }

});
